import { createContext, ReactChild, ReactFragment, ReactPortal, useState } from 'react';
import { IInventoryEntity, IOrderEntity, KeyValueRecord } from '@rasayi-workspace/shared';

const order = {
    progress: { value: 'string', title: 'string' },
    setProgress: (value: string, title: string) => {
        return;
    },
    lastAccess: '',
    setLastAccess: (newValue: string) => {
        return;
    },
    userId: '',
    setUserId: (newValue: string) => {
        return;
    },
    user: {} as KeyValueRecord,
    setUser: (newValue: KeyValueRecord) => {
        return;
    },
    orderId: '',
    setOrderId: (newValue: string) => {
        return;
    },
    userIdValidated: false,
    setUserIdValidated: (newValue: boolean) => {
        return;
    },
    guarantorId: '',
    setGuarantorId: (newValue: string) => {
        return;
    },
    inventories: [] as IInventoryEntity[],
    setInventories: (newValue: IInventoryEntity[]) => {
        return;
    },
    orderDetails: {} as KeyValueRecord,
    setOrderDetails: (newValue: KeyValueRecord) => {
        return;
    },
    incompleteOrder: true,
    setIncompleteOrder: (newValue: boolean) => {
        return;
    },
    initialInventories: [] as IInventoryEntity[],
    setInitialInventories: (newValue: IInventoryEntity[]) => {
        return;
    }
};

export const orderContext = createContext(order);

export function OrderContextProvider(props: { children: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined; }): JSX.Element {
    const [progress, setProgress] = useState({ value: '1', title: 'Phone Number' });

    const [userId, setUserId] = useState('');

    const [lastAccess, setLastAccess] = useState('');

    const [user, setUser] = useState<KeyValueRecord>({});

    const [orderId, setOrderId] = useState('');

    const [userIdValidated, setUserIdValidated] = useState(false);

    const [guarantorId, setGuarantorId] = useState('');

    const [orderDetails, setOrderDetails] = useState<KeyValueRecord>({} as IOrderEntity);

    const [inventories, setInventories] = useState<IInventoryEntity[]>([]);

    const [incompleteOrder, setIncompleteOrder] = useState(true);

    const [initialInventories, setInitialInventories] = useState<IInventoryEntity[]>([]);

    const updateProgress = (value: string, title: string): void => {
        setProgress({ value, title });
    };

    const updateUserId = (newValue: string): void => {
        setUserId(newValue);
    };

    const updateLastAccessId = (newValue: string): void => {
        setLastAccess(newValue);
    };

    const updateUser = (newValue: KeyValueRecord): void => {
        setUser(newValue);
    };

    const updateOrderId = (newValue: string): void => {
        setOrderId(newValue);
    };

    const updateUserIdValidated = (newValue: boolean): void => {
        setUserIdValidated(newValue);
    };

    const updateGuarantorId = (newValue: string): void => {
        setGuarantorId(newValue);
    };

    const updateInventories = (newValue: IInventoryEntity[]): void => {
        setInventories(newValue);
    };

    const updateOrderDetails = (newValue: KeyValueRecord): void => {
        setOrderDetails(newValue);
    };

    const updateIncompleteOrder = (newValue: boolean): void => {
        setIncompleteOrder(newValue);
    };

    const updateInitialInventories = (newValue: IInventoryEntity[]): void => {
        setInitialInventories(newValue);
    };

    /*
      updateTheme is meant to be an example of a method that can do more than just updating the theme state.
      For example, it could be a method that triggers a fetch request, in which updating the state is not a direct step.
    */

    return (

        <orderContext.Provider value={ {
            progress, setProgress: updateProgress,
            userId, setUserId: updateUserId,
            lastAccess, setLastAccess: updateLastAccessId,
            orderId, setOrderId: updateOrderId,
            userIdValidated, setUserIdValidated: updateUserIdValidated,
            guarantorId, setGuarantorId: updateGuarantorId,
            inventories, setInventories: updateInventories,
            incompleteOrder, setIncompleteOrder: updateIncompleteOrder,
            orderDetails, setOrderDetails: updateOrderDetails,
            initialInventories, setInitialInventories: updateInitialInventories,
            user, setUser: updateUser
        } }>
            { props.children }
        </orderContext.Provider>
    );
}